export namespace NotificationTypeConstants {
  export const APPROVAL_NEEDED = 'APPROVAL';
  export const CHANGE_REQUEST_ACCEPTED = 'ACCEPTED';
  export const CHANGE_REQUEST_REJECTED = 'REJECTED';
  export const CHANGE_REQUEST_EXPIRED = 'EXPIRED';
}
